var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rules"},[_vm._v(" 购买书币说明： "),_vm._l((_vm.baseInfo),function(item,index){return _c('p',{key:item},[_vm._v(_vm._s(index + 1)+"."+_vm._s(item))])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }